import { render } from "./duplicate_button.vue?vue&type=template&id=420c53ad&scoped=true&lang=pug"
import script from "./duplicate_button.vue?vue&type=script&lang=js"
export * from "./duplicate_button.vue?vue&type=script&lang=js"

import "./duplicate_button.vue?vue&type=style&index=0&id=420c53ad&lang=scss&scoped=true"

import exportComponent from "../../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-420c53ad"]])

export default __exports__